export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/noop.js
// module id = 92
// module chunks = 0